import { number, object, string } from 'yup';
import { inventoryStatusValues } from '@/features/inventory/inventory.constants';

const blankToUndefined = (value: number, raw: unknown) =>
  raw === '' || raw === null || raw === undefined || Number.isNaN(value)
    ? undefined
    : value;

// A signed euro change; a blank field is no change at all.
const defaultAmount = number()
  .transform((value: number, raw: unknown) =>
    blankToUndefined(value, raw) === undefined ? 0 : value
  )
  .default(0)
  .label('Default amount');

/**
 * `companyId` is only honoured for a super Admin; for anyone else the API uses
 * the caller's own company. Sent on create only: the update DTOs do not take it.
 * `status` is the wire value itself: active, inactive or suspended (what
 * Delete writes), picked like the Smart Suggestion forms.
 */
const ageGroupPresetValidationSchema = object({
  companyId: string().required().label('Company ID'),
  label: string().trim().required().label('Age group'),
  defaultAmount,
  order: number()
    .transform(blankToUndefined)
    .integer()
    .min(1)
    .optional()
    .label('Order'),
  status: string().oneOf(inventoryStatusValues).default('active'),
});

const groupSizePresetValidationSchema = object({
  companyId: string().required().label('Company ID'),
  label: string().trim().optional().label('Label'),
  minParticipant: number()
    .transform(blankToUndefined)
    .integer()
    .min(1)
    .required()
    .label('From'),
  maxParticipant: number()
    .transform((value: number, raw: unknown) =>
      blankToUndefined(value, raw) === undefined ? null : value
    )
    .nullable()
    .integer()
    .min(1)
    .test('not-below-min', 'Must be at least the From value', function (value) {
      const min = this.parent?.minParticipant;
      return value === null || value === undefined || !min
        ? true
        : value >= min;
    })
    .label('To'),
  defaultAmount,
  status: string().oneOf(inventoryStatusValues).default('active'),
});

export { ageGroupPresetValidationSchema, groupSizePresetValidationSchema };
